import { Component } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NotificationService } from '@app/layouts/topbar/notifications/notifications.service';
import { Observable } from 'rxjs';
import { Notification } from '@app/layouts/topbar/notifications/notification';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LocalizedDatePipe } from '@shared/pipes/localized-date.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { Resources } from '@app/resources';
import { ResourceByIdPipe } from '@shared/pipes/resource-by-id.pipe';
import { ApiService } from '@shared/services/api.service';

@Component({
  selector: 'notifications',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownToggle,
    SimplebarAngularModule,
    NgIf,
    AsyncPipe,
    RouterLink,
    NgForOf,
    LocalizedDatePipe,
    TranslatePipe,
    ResourceByIdPipe
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent {
  public notifications$: Observable<Notification[]>;
  public currentPage = 1;
  public showLoadMore = true;
  protected readonly Resources = Resources;

  constructor(protected ns: NotificationService, protected api: ApiService) {
    this.notifications$ = this.ns.notifications$;
  }

  mark(id: string) {
    this.ns.markAsRead(id);
  }

  loadMore() {
    this.currentPage++;
    this.api.get<{ data: { data: Notification[] } }>('/notifications/unread', {
      page: this.currentPage,
    }).subscribe(response => {
      this.ns._notifications$.next(this.ns._notifications$.value.concat(response.data.data))
      if (response.data.data.length == 0) {
        this.showLoadMore = false;
      }
    });
  }
}
